import { makeStyles } from '@material-ui/core/styles';

import { fontWeight } from '../../theme/typography';

export const useStyles = makeStyles(theme => ({
  textContainer: {
    display: 'flex',
    marginTop: theme.spacing(5.25),
    alignItems: 'center',
  },
  mainTitle: {
    fontSize: theme.typography.h3.fontSize,
    fontFamily: theme.typography.secondaryFontFamily,
    fontWeight: fontWeight.bold,
    marginRight: theme.spacing(3.75),
  },
  subtitle: {
    fontSize: theme.typography.h6.fontSize,
    color: theme.palette.text.secondary,
    margin: `auto ${theme.spacing(0.5)}px`,
  },
  box: {
    padding: theme.spacing(2.5, 2.75, 2, 2.75),
    backgroundColor: theme.palette.gray.dark,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: theme.palette.secondary.main,
  },
}));
